import errorHandler from '../utils/errorHandler';
import API from '../utils/API';
import { setMeasures, toggleLoadDishes } from './dishSearch';

export const getDishesSuccess = (data) => {
  return {
    type: 'GET_DISHES_SUCCESS',
    data,
  };
};

export const setDishFromQueryParams = (data) => {
  return {
    type: 'SET_DISH_FROM_QUERY_PARAMS',
    data,
  };
};

export const getDishes = (searchName = '') => {
  return (dispatch) => {
    dispatch(toggleLoadDishes());
    API.get(`/dishes?search=${searchName}`)
      .then((response) => {
        dispatch(getDishesSuccess(response.data.data.items.dishes.data));
        dispatch(setMeasures(response.data.data.items.measures));
        dispatch(toggleLoadDishes());
      })
      .catch(function (error) {
        const errorConfig = {
          404: {
            message: 'Блюда не найдены',
          },
          400: {
            message: 'Получить блюда не удалось',
          },
        };
        dispatch(toggleLoadDishes());
        if (error && error.response && error.response.status) {
          errorHandler(error.response.status, errorConfig);
        }
      });
  };
};

export const setDishReadyToUpgrade = () => {
  return {
    type: 'SET_DISH_READY_TO_UPGRADE',
  };
};

export const setDishUpgrade = () => {
  return {
    type: 'SET_DISH_UPGRADE',
  };
};

export const getDishesFromId = (id = '') => {
  return (dispatch) => {
    dispatch(toggleLoadDishes());
    API.get(`/dishes/${id}`)
      .then((response) => {
        dispatch(setDishFromQueryParams(response.data.data.items));
        dispatch(setDishReadyToUpgrade());
        dispatch(toggleLoadDishes());
      })
      .catch(function (error) {
        const errorConfig = {
          404: {
            message: 'Блюда не найдены',
          },
          400: {
            message: 'Получить блюда не удалось',
          },
        };
        dispatch(toggleLoadDishes());
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/dishes.js